export function Settings() {
    const ssoId = process.env.API_ENDPOINT.includes("dev") ? 16050 : 5450;
    const ssoUrl = 'https://awavedemo.csod.com';

    return {
        "front": {
            "authorization": true,
            "hideHeaderInCSOD": true,
            "ssoUrlBase": ssoUrl + '/outboundsso.aspx?ou_id=-'+ ssoId +'&returnUrl=' + encodeURIComponent(window.location.href) + '&ticket='
        },
        "admin": {
            "authorization": true,
            "hideHeaderInCSOD": true,
            "ssoUrlBase": ssoUrl + '/outboundsso.aspx?ou_id=-'+ ssoId +'&returnUrl=' + encodeURIComponent(window.location.href) + '&ticket='
        }
    };
}


// WEBPACK FOOTER //
// ./src/projectSettings.js